import Constant from '@/const';
import axios from 'axios';

const getDinkesDataByServiceType = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/dinkes/service-type'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDinkesDataByServiceType;
